import $ from "jquery";

export default class HelpShiftContentRequester {

    constructor(toDiv, navDiv) {
        this.contentDiv = toDiv;
        this.navDiv = navDiv;
    }

    requestCategory(categoryId, url = '', scrollTimeout = null) {
        if (this.isCurrentPageCategory() && this.getMaterialIdFromUrl() === categoryId)
            return;

        $.get('/help/ajax-renderer/category-content', {id: categoryId}, (data) => {
            this.contentDiv.html(data);
        }).done(() => {
            this.moveParentPath();

            this.updateHistory(url);

            window.scrollTo({top: 0});
        });
    }

    requestArticle(articleId, url = '') {
        if (this.isCurrentPageArticle() && this.getMaterialIdFromUrl() === articleId)
            return;

        $.get('/help/ajax-renderer/article-content', {id: articleId}, (data) => {
            this.contentDiv.html(data);
        }).done(() => {
            this.moveParentPath();

            this.updateHistory(url);
        });
    }

    isCurrentPageArticle() {
        return this.getParsedUrl()[0] === 'article';
    }

    isCurrentPageCategory() {
        return this.getParsedUrl()[0] === 'category';
    }

    getMaterialIdFromUrl() {
        return parseInt(this.getParsedUrl()[1]);
    }

    getParsedUrl() {
        return (window.location.pathname).split('/').slice(2);
    }

    pushState(url, title = '') {
        history.pushState(null, title, url);
    }

    moveParentPath() {
        const path = this.contentDiv.find('.material-parents-path');

        this.navDiv.find('.material-parents-path').html(path.html());

        path.remove();
    }

    updateHistory(url) {
        if (url.length === 0) {
            return;
        }

        const title = this.contentDiv.find('.help-system__title').first().text();

        document.title = title;

        this.pushState(url, title);
    }
}
